import { RootAppState } from 'store/configureStore'

export const projectDiscountValueSelector = (state: RootAppState) => {
  if (state.project.activeProject?.financial?.discountValueOfItems == null) {
    return null
  }
  return state.project.activeProject?.financial.discountValueOfItems
}
